/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TransfersScheduleState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRANSFERS_SCHEDULE_STATE_ENTITY_NAME = 'ixf.hours.v1.TransfersSchedule';
export const ixfHoursV1TransfersScheduleStateEntity = new schema.Entity<IxfHoursV1TransfersScheduleState>(IXF_HOURS_V1_TRANSFERS_SCHEDULE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1TransfersScheduleState) => `${entity.region}-${entity.exposure}` });

